import React from 'react'
import PropTypes from 'prop-types'

import Horario from './horario'
import GruposCombo from './grupos_combo'

export default class HorarioList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gruposPorHora: parseInt(props.gruposPorHora)
    };
    this.onChangeGrupos = this.onChangeGrupos.bind(this);
    this.renderChildren = this.renderChildren.bind(this);
  }

  renderChildren ({ hora, vagas, reservas }) {
    return <Horario key={hora} hora={hora} vagas={vagas} reservas={reservas} gruposPorHora={this.state.gruposPorHora}  />;
  }

  onChangeGrupos (e) {
    this.setState({ gruposPorHora: parseInt(e.target.value) });
  }

  render () {
    return (
      <div>
        <table className="horarios table table-condensed">
          <tbody>
            <tr>
              <th width="60px">&nbsp;</th>
              <th colSpan="3" className="td-internet">INTERNET</th>
              <th colSpan="3" className="td-lotes">BALCÃO</th>
              <th colSpan="3" className="td-total">CAPACIDADE TOTAL</th>
              <th colSpan="2">&nbsp;</th>
            </tr>
            <tr className="no-border">
              <th width="70px">&nbsp;</th>
              <th className="td-internet field">Vagas</th>
              <th colSpan="2" className="td-internet">Reservas</th>
              <th className="td-lotes field">Vagas</th>
              <th colSpan="2" className="td-lotes">Senhas</th>
              <th className="td-total field">Vagas</th>
              <th colSpan="2" className="td-total">Ocupadas</th>
              <th width="60px">&nbsp;</th>
              <th width="320px">&nbsp;</th>
            </tr>
            {this.props.horarios.map(this.renderChildren)}
          </tbody>
        </table>
        <hr/>
        <GruposCombo onChange={this.onChangeGrupos} gruposPorHora={this.state.gruposPorHora} />
      </div>
    );
  }

}
